/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { styled } from '@mui/material/styles';
import {
  ListItemButton as MuiListItemButton,
  Typography as MuiTypography,
  ListItemIcon as MuiListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Collapse,
  List,
  Stack,
} from '@mui/material';
import { SubMenuItem } from './SubMenuItem';

const ListItemIcon = styled(MuiListItemIcon)(({ theme }) => ({
  color: theme.palette.common.white,
}));

const ListItemButton = styled(MuiListItemButton, {
  shouldForwardProp: (prop) => prop !== 'wide',
})(({ theme }) => ({
  borderRadius: '6px',
  '&.Mui-selected': {
    backgroundColor: theme.palette.primary.dark,
    fontSize: '18px',
    borderRadius: '6px',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
    fontSize: '18px',
    borderRadius: '6px',
  },
  padding: '8px 10px',
}));

const Typography = styled(MuiTypography, {
  shouldForwardProp: (prop) => prop !== 'wide' && prop !== 'selected',
})(({ wide }) => ({
  fontSize: '14px',
  fontWeight: '400',
  ...(!wide && {
    paddingLeft: '9px',
    display: 'none',
  }),
}));

export const SubMenu = ({ item, wide, sx, toggleWide }) => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const handleOpenMenu = (event) => setAnchorEl(event.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);

  const isMenuOpen = Boolean(anchorEl);

  const isSelected = (item) => {
    const pathnames = location.pathname.split('/').filter((x) => x);
    const selected = pathnames.some((path) => {
      return item.path.split(',').some((itemPath) => itemPath.toLocaleLowerCase() === path);
    });
    return selected;
  };

  const isSelectedMenuItem = (item) => {
    return location.pathname === item.path;
  };

  const handleClick = () => {
    if (!wide) {
      toggleWide;
      setOpen(true);
      return;
    }
    setOpen(!open);
  };

  const selectedSubMenuItem = item.subNav.find((nav) => location.pathname === nav.path);

  const hasAutoOpened = useRef(false);

  useEffect(() => {
    if (selectedSubMenuItem && !hasAutoOpened.current) {
      setOpen(true);
      hasAutoOpened.current = true;
    }
  }, [location.pathname]);

  return (
    <Stack sx={{ width: '100%' }}>
      <ListItemButton
        component="div"
        sx={{ sx }}
        selected={isSelected({ path: item.title })}
        onClick={wide ? handleClick : handleOpenMenu}
        data-testid="submenu"
      >
        <ListItemIcon>{item.icon}</ListItemIcon>
        <ListItemText
          primary={
            <Typography
              variant="subtitle2"
              wide={wide}
              data-testid="submenu-title"
            >
              {item.title}
            </Typography>
          }
        />
      </ListItemButton>
      {wide && (
        <Collapse
          in={wide ? open : false}
          timeout="auto"
          unmountOnExit
          sx={{ overflowX: 'hidden', py: 0.9 }}
        >
          <List
            component="div"
            disablePadding
            data-testid="submenu-list"
          >
            {item.subNav.map((nav, index) => (
              <SubMenuItem
                key={index}
                item={nav}
                sx={{ minHeight: 32, pl: 3 }}
                wide={wide}
                selected={isSelectedMenuItem(nav)}
              />
            ))}
          </List>
        </Collapse>
      )}
      {!wide && (
        <Menu
          anchorEl={anchorEl}
          open={isMenuOpen}
          onClose={handleCloseMenu}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          MenuListProps={{ dense: true }}
        >
          {item.subNav.map((nav, index) => (
            <MenuItem
              key={index}
              onClick={() => {
                navigate(nav.path);
                handleClick();
                handleCloseMenu();
              }}
            >
              {nav.title}
            </MenuItem>
          ))}
        </Menu>
      )}
    </Stack>
  );
};
